/*=========================================================================================
  File Name: moduleCountryMutations.js
  Description: Country Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ADD_ITEM(state, item) {
    state.PropertyCatgeorys.unshift(item)
  },
  SET_PropertyCatgeorys(state, _PropertyCatgeorys) {
    debugger;
    try {
 
      state.PropertyCatgeorys = _PropertyCatgeorys;
     
    } catch (error) {
      console.error("Failed to parse PropertyCatgeorys data JSON:", error);
      state.PropertyCatgeorys = [];
    }
  },
  UPDATE_PropertyCatgeory(state, PropertyCatgeory) {
    debugger
    const PropertyCatgeoryIndex = state.PropertyCatgeorys.findIndex((p) => p.Id == PropertyCatgeory.Id)
    Object.assign(state.PropertyCatgeorys[PropertyCatgeoryIndex], PropertyCatgeory)
  },
  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.PropertyCatgeorys.findIndex((p) => p.ID == itemId)
      state.PropertyCatgeorys.splice(ItemIndex, 1)
  },
}
